// ============================================================================
// JobImportForm Component (View)
// ============================================================================

import { Box } from "@mui/material";
import { useJobImportFormViewModel } from "./JobImportForm.vm";
import { ValidationErrorsContext } from "../../ImportTable/ImportTable/shared/hooks/ValidationErrorsContext";
import { JobFormFields } from "../JobFormFields";
import { JobCardMap } from "../../ImportTable/ImportTable/mobile/JobCard/JobCardMap";
import { JobImportFormProps } from "./JobImportForm.types";

/**
 * Form component for editing job data with validation.
 * Uses the shared JobFormFields component for consistent form layout.
 */
export function JobImportForm(props: JobImportFormProps) {
	const vm = useJobImportFormViewModel(props);
	const {
		currentJob,
		columnContext,
		isVisible,
		localValidationErrors,
		gridSizes,
		depths,
		labPackages,
		micros,
		showMoreFields,
		toggleShowMoreFields,
	} = vm;
	const { branches = [] } = props.formContext;

	return (
		<ValidationErrorsContext.Provider value={localValidationErrors}>
			<Box sx={{ display: "flex", gap: 2, minHeight: 400, flex: 1 }}>
				{/* Form Fields - Left Side */}
				<Box sx={{ flex: "0 0 60%", overflowY: "auto", pr: 2, pt: 1 }}>
					<JobFormFields
						job={currentJob}
						columnContext={columnContext}
						dropdownOptions={{ gridSizes, depths, labPackages, micros }}
						branches={branches}
						isVisible={isVisible}
						showMoreFields={showMoreFields}
						onToggleShowMore={toggleShowMoreFields}
					/>
				</Box>

				{/* Map Preview - Right Side */}
				<Box sx={{ flex: 1, minWidth: 0, borderLeft: 1, borderColor: "divider", pl: 2 }}>
					<JobCardMap job={currentJob} height="100%" />
				</Box>
			</Box>
		</ValidationErrorsContext.Provider>
	);
}
